import { render, staticRenderFns } from "./AbstractSetting.vue?vue&type=template&id=3edb874e&scoped=true&"
import script from "./AbstractSetting.vue?vue&type=script&lang=ts&"
export * from "./AbstractSetting.vue?vue&type=script&lang=ts&"
import style0 from "./AbstractSetting.vue?vue&type=style&index=0&id=3edb874e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edb874e",
  null
  
)

export default component.exports